import EditBookingHeader from "./EditBookingHeader";

export default EditBookingHeader;
